// /blackUsers 상태 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

// 권한(auth)
export const authMeta: Record<string, StatusMeta> = {
  DIRECTOR: { label: "시설 관리자", color: "primary" },
  TEACHER: { label: "교사", color: "default" },
};

// 계정 상태(userStatus)
export const userStatusMeta: Record<string, StatusMeta> = {
  RESTRICTED_SEVEN_DAYS: { label: "7일간 정지", color: "warning" },
  BAN: { label: "영구정지", color: "error" },
  WITHDRAWN: { label: "탈퇴", color: "default" },
};

// 매핑에 없는 값도 안전하게 표시 (기존 default: 원본 값 그대로 노출)
export const resolveStatusMeta = (
  map: Record<string, StatusMeta>,
  value: unknown
): StatusMeta => {
  const key = value === null || value === undefined ? "" : String(value);
  return map[key] ?? { label: key || "-", color: "default" };
};
